import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { API_URL } from 'src/app/app.contant';
import { PO_DATA } from '../../dashboard/mock';
import { IAPIResponse, IBuyerRC } from '../../shared/models';
import { IMaterialCodeDetail, IPlantDetail, IVendorCodeDetail } from '../models';
import { EncryptionService } from '../../dashboard/services/encryption.service';
import { AuthService } from '../../core/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PrInitiatorService {

  constructor(private http: HttpClient,private _encryptionService : EncryptionService,private _authService : AuthService,) { }

  public materialMasterDeliveryDate: any = ''; 

  public getInitiatedPRs(): Observable<Array<any>> {
    // return this.http.get<Array<any>>(`${API_URL.PO}`);
    return of(PO_DATA);
  }

  // TBD add appropriate interfaces
  public createPR(purchaseRequest : any, prFiles?: any) : Observable<any> {
    let formData: FormData = new FormData;
    formData.append("prData", JSON.stringify(purchaseRequest));
    if(prFiles?.length){
      prFiles.forEach((element:any) => {
        formData.append("files", element)
      });
    } else{
      formData.append("files","");
    }
    return this.http.post<any>(`${API_URL.CREATE_PR}`, formData);
    // return of(true)
  }
// TBD add appropriate interfaces
  public updatePR(purchaseRequest : any) : Observable<any> {
    return this.http.post<any>(`${API_URL.UPDATE_PR}`, purchaseRequest);
  }

  // Bulk upload
  public createBulkPR(uploadedFile: FormData) : Observable<any> {
    return this.http.post<any>(`${API_URL.CREATE_BULK_PR}`,uploadedFile);
  }

  public fetchPrForPreview(prId:any) : Observable<any> {
    return this.http.get<any>(`${API_URL.GET_ALL_PR}?prId=${prId}`);
  }

  public pendingLineItemsApprovalFromManager(prId:any) : Observable<any> {
return this.http.get<any>(`${API_URL.PENDING_LINEITEM_APPROVAL}?prId=${prId}`)
  }

  // fetch rc list
  public fetchRCList() : Observable<IAPIResponse<Array<IBuyerRC>>> {
    return this.http.get<IAPIResponse<Array<IBuyerRC>>>(`${API_URL.BUYER.RCGET}`);
  }

  // fetch detail by plant
  public detailByPlant(body : any) : Observable<IAPIResponse<IPlantDetail>> {
    return this.http.post<IAPIResponse<IPlantDetail>>(`${API_URL.FETCH_BY_PLANT_DETAILS}`, body);
  }

  // fetch detail by material code
  public detailByMaterialCode(material_code : any, plant : any) : Observable<IAPIResponse<IMaterialCodeDetail>> {
    return this.http.get<IAPIResponse<IMaterialCodeDetail>>(`${API_URL.FETCH_BY_MATERIAL_DETAILS}material_code=${this._encryptionService.encryptPayload(material_code)}&plant=${this._encryptionService.encryptPayload(plant)}`);
  }

  // fetch detail by service code
  public detailByServiceCode(material_code: any) : Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.FETCH_BY_SERVICE_CODE}${material_code}`);
  }

  // fetch detail by service code and service Category
  public detailByServiceCodeAndCategory(material_code: any,category:any) : Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.FETCH_BY_SERVICE_CODE_AND_CATEGORY}${this._encryptionService.encryptPayload(material_code)}&category=${this._encryptionService.encryptPayload(category)}`);
  }

   // fetch detail by service code and service Category
   public detailByServiceCodeAndCategoryOther(material_code: any) : Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.FETCH_BY_SERVICE_CODE_AND_CATEGORY_OTHER}${material_code}`);
  }

   // fetch detail by material code
   public detailByVendorCode(vendor_code : any, purchase_org : any) : Observable<IAPIResponse<IVendorCodeDetail>> {
    return this.http.get<IAPIResponse<IVendorCodeDetail>>(`${API_URL.FETCH_BY_VENDOR_DETAILS}vendor=${this._encryptionService.encryptPayload(vendor_code)}&purchase_org=${this._encryptionService.encryptPayload(purchase_org)}`);
  }

   // Upload Pr attachments
   public uploadPRAttachments(prId : any, file : any) : Observable<IAPIResponse<IVendorCodeDetail>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.PR_UPLOAD_ATTACHMENTS}`,file);
  }

  //fetch files for PRId
  public getFilesForPrId(prId:any){
    return this.http.get<IAPIResponse<any>>(`${API_URL.FETCH_PR_FILES}`+ prId)
  }

  //download files by Id
  public downloadFilesByFileId(fileId:any){
    return this.http.get<any>(`${API_URL.DOWNLAOD_PR_FILES}`+fileId, {
      responseType: 'blob' as any,
    });
  }

  public deleteFilesByFileId(payload:any){
    return this.http.post<IAPIResponse<any>>(`${API_URL.DELETE_PR_FILES}`, payload);
  }

  public searchESN(label:string):Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.GET_SERVICE_ESN_BY_SHORT_TEXT}`,{"label" : label})
  }

  public calculateRcTotalAmount(prId:any){
    return this.http.post<IAPIResponse<any>>(`${API_URL.CALCULATE_RC_TOTAL_AMOUNT}`,{'prId':prId});
  }

  public getServiceMasterCategory():Observable<IAPIResponse<any>>{
    return this.http.get<IAPIResponse<any>>(`${API_URL.GET_SERVICE_CATEGORY}`)
  }

  public fetchReportingManagers(prId?: any): Observable<IAPIResponse<any>> {
    if (prId) {
      return this.http.get<IAPIResponse<any>>(`${API_URL.FETCH_PR_APPROVER_DETAILS}?prId=${prId}`)
    }
    return this.http.get<IAPIResponse<any>>(`${API_URL.FETCH_PR_APPROVER_DETAILS}`)
  }

  public approveRejectPR(payload:any){
    return this.http.post<IAPIResponse<any>>(`${API_URL.APPROVE_REJECT_PR}`,payload);
  }
  public fetchBulkPRHistory(){
    return this.http.get<IAPIResponse<any>>(`${API_URL.GET_BULK_PR_HISTORY}`)
  }
  public convertToPR(){
    return this.http.post<IAPIResponse<any>>(`${API_URL.CONVERT_TO_PR}`,{})
  }
  public clearPr(payload: any){
    return this.http.post<IAPIResponse<any>>(`${API_URL.CLEAR_PR}`,payload)
  }
}
